import { SVGProps } from "react";

export function AppleLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" {...props}>
      <path
        d="M8.49904 4.81477C7.91504 4.81477 7.01104 4.15077 6.05904 4.17477C4.80304 4.19077 3.65104 4.90277 3.00304 6.03077C1.69904 8.29477 2.66704 11.6388 3.93904 13.4788C4.56304 14.3748 5.29904 15.3828 6.27504 15.3508C7.21104 15.3108 7.56304 14.7428 8.69904 14.7428C9.82704 14.7428 10.147 15.3508 11.139 15.3268C12.147 15.3108 12.787 14.4148 13.403 13.5108C14.115 12.4708 14.411 11.4628 14.427 11.4068C14.403 11.3988 12.467 10.6548 12.443 8.41477C12.427 6.54277 13.971 5.64677 14.043 5.60677C13.163 4.31877 11.811 4.17477 11.339 4.14277C10.107 4.04677 9.07504 4.81477 8.49904 4.81477ZM10.579 2.92677C11.099 2.30277 11.443 1.43077 11.347 0.566772C10.603 0.598772 9.70704 1.06277 9.17104 1.68677C8.69104 2.23877 8.27504 3.12677 8.38704 3.97477C9.21104 4.03877 10.059 3.55077 10.579 2.92677Z"
        fill="currentColor"
      />
    </svg>
  );
}
